import { Component, type ErrorInfo, type ReactNode } from "react";
import { RefreshCw, TriangleAlert } from "lucide-react";

interface Props {
  children: ReactNode;
  compact?: boolean;
}

interface State {
  error: Error | null;
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("UI render failure", error, info.componentStack);
  }

  private retry = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className={this.props.compact ? "py-8" : "flex min-h-[55vh] items-center justify-center py-10"} role="alert">
        <div className="surface-card mx-auto max-w-xl p-7 text-center sm:p-9">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-danger-50 text-danger-600">
            <TriangleAlert className="h-5 w-5" aria-hidden="true" />
          </span>
          <h2 className="mt-5 text-lg font-black text-[var(--color-text-primary)]">این بخش به‌درستی نمایش داده نشد</h2>
          <p className="mt-2 text-sm leading-7 text-[var(--color-text-secondary)]">
            داده این بخش ساختار مورد انتظار را نداشت. می‌توانید دوباره تلاش کنید؛ سایر قسمت‌های صفحه همچنان در دسترس‌اند.
          </p>
          <button onClick={this.retry} className="mt-5 inline-flex min-h-11 items-center gap-2 rounded-xl bg-tapsi-500 px-5 text-sm font-bold text-white transition-colors hover:bg-tapsi-600 focus-visible:ring-4 focus-visible:ring-tapsi-500/20">
            <RefreshCw className="h-4 w-4" aria-hidden="true" /> تلاش دوباره
          </button>
        </div>
      </div>
    );
  }
}
